import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import AccessoryInfoItem from '../accessory-info-item';
import './styles.css';

/**
 *  AccessoryInfoContainer
 */
class AccessoryInfoContainer extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    items: PropTypes.array
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    items: null
  };
  
  constructor(props) {
    super();
    this.props = props;
  }
  
  render() {
    const {
      containerId,
      containerClass,
      anchorPoint,
      anchorName,
      items
    } = this.props;
        
    //
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
        anchorPoint={anchorPoint}
        anchorName={anchorName}
      >
        <div className='AccessoryInfoContainer'>
          <div className='AccessoryInfoContainer__container'>
          {items.map((item, index) => {
            return(
              <AccessoryInfoItem {...item.props} key={index} />
            )
          })}
          </div>
        </div>
      </Wrapper>
    )
  }
  
}

export default AccessoryInfoContainer;



// WEBPACK FOOTER //
// ./src/containers/accessory-info-container/index.jsx